import React, { Component } from 'react'
import { connect } from 'react-redux'

import { selectors as UsersSelectors } from 'data/users'

import Button from 'components/base/Button'
import Timeago from 'components/Utils/Timeago'
import { Toggle } from 'components/base'
import { Text } from 'components/base'

class NotesHistoryHeader extends Component {
  render() {
    const {
      onRevert,
      onClose,
      activeVersion,
      usernames,
      showHistoryDecorators,
      setShowHistoryDecorators,
    } = this.props

    return (
      <div className="flexbox-grow flexbox padding-horizontal-large padding-vertical-normal">
        <div className="flexbox-grow flexbox flexbox-column flexbox-justify-center">
          <div className="bold margin-bottom-smaller">
            <Timeago date={activeVersion.get('createdAt')} />
          </div>
          {usernames.length > 0 && (
            <div className="shade-20 flexbox font-size-small">
              <div>By</div>
              {usernames.map(username => (
                <Text.Name key={username}>
                  <div className="font-size-small margin-left-smaller">
                    @{username}
                  </div>
                </Text.Name>
              ))}
            </div>
          )}
        </div>
        <div className="margin-left-auto margin-right-normal" />
        <label className="flexbox flexbox-align-center flexbox-space-between shade-10 font-size-small margin-right-normal">
          <div className="margin-right-normal">See all changes</div>
          <Toggle
            checked={showHistoryDecorators}
            onChange={() => setShowHistoryDecorators(!showHistoryDecorators)}
          />
        </label>
        <Button.Secondary className="margin-right-normal" onClick={onClose}>
          Cancel
        </Button.Secondary>
        <Button.Primary onClick={onRevert}>Restore</Button.Primary>
      </div>
    )
  }
}

export default connect((state, { activeVersion }) => ({
  usernames: activeVersion
    .get('userIds')
    .map(userId => UsersSelectors.getUser(state, userId))
    .filter(x => x)
    .map(user => user.get('username')),
}))(NotesHistoryHeader)
